export default __webpack_public_path__ + "static/media/soundcloud.5edabff3.png";